/*
Auto-generated by: https://github.com/pmndrs/gltfjsx
*/

import React, { useRef,useEffect } from 'react'
import { useGLTF, useAnimations } from '@react-three/drei'

export default function Model({ ...props }) {
  const group = useRef()
  const { nodes, materials, animations } = useGLTF('/MassageGun/gunHead4.glb')
  const { actions } = useAnimations(animations, group)
  useEffect(() => {
    actions.Animation7.play();
    actions.Animation7.repetitions = 1;
    actions.Animation7.clampWhenFinished = true;
  }, [actions]);
  return (
    <group ref={group} {...props} dispose={null}>
      <group>
        <group name="head4" position={[0.08, 0.08, 0]} rotation={[0, 0, 0.08]}>
          <mesh geometry={nodes.圓柱體008.geometry} material={materials['材質.006']} />
          <mesh geometry={nodes.圓柱體008_1.geometry} material={materials['材質.005']} />
        </group>
      </group>
    </group>
  )
}

useGLTF.preload('/MassageGun/gunHead4.glb')
